<template>
	<div style="padding: 20px;">
		<el-form
			ref="form"
			:model="form"
			:rules="rules"
			label-width="560px"
			v-if="active == 0"
		>
			<el-form-item label="抖音视频标题" prop="title">
				<el-input
					clearable
					v-model="form.title"
					placeholder="请填写标题"
				></el-input>
			</el-form-item>
			<el-form-item label="门店" prop="room_id">
				<el-select
					v-model="form.room_id"
					filterable
					placeholder="请选择门店"
					style="width: 350px;"
					clearable
				>
					<el-option
						v-for="(item, i) in roomList"
						:key="i"
						:label="item.name"
						:value="item.id"
					>
						<span
							style="display: inline-block;width: 100%;height: 100%;"
							@click="room_select(item)"
							>{{ item.name }}</span
						>
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="门店省/市/区" prop="selectedOptions">
				<el-cascader
					clearable
					:options="options"
					v-model="form.selectedOptions"
					@change="liandong_val"
					style="width: 350px;"
					:props="{ value: 'label' }"
				>
				</el-cascader>
			</el-form-item>
			<el-form-item label="门店详细地址" prop="address">
				<el-input
					style="width: 350px;"
					type="textarea"
					v-model="form.address"
					placeholder="请填写详细地址"
				></el-input>
			</el-form-item>
			<el-form-item label="抖音地理位置" prop="poi_name">
				<el-select
					clearable
					v-loadmore="Douyin_dizhi_load"
					v-model="form.poi_name"
					filterable
					style="width: 350px;"
					placeholder="请选择"
					@visible-change="visibleChange"
					@change="val"
				>
					<el-option
						v-for="(item, i) in douyin_Location"
						:key="i"
						:label="item.poi_name"
						:value="item.poi_name"
					>
						<span
							style="display: inline-block;width: 100%;height: 100%;"
							@click="douyin_select(item)"
							>{{ item.poi_name }}</span
						>
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="经纬度">
				<div>{{ form.location }}</div>
			</el-form-item>
			<el-form-item label="开始时间">
				<el-date-picker
					v-model="form.start_time"
					type="datetime"
					value-format="yyyy-MM-dd HH:mm:ss"
					placeholder="选择开始日期时间"
				>
				</el-date-picker>
			</el-form-item>
			<el-form-item label="结束时间">
				<el-date-picker
					v-model="form.end_time"
					value-format="yyyy-MM-dd HH:mm:ss"
					type="datetime"
					placeholder="选择结束日期时间"
				>
				</el-date-picker>
			</el-form-item>
			<el-form-item label="上传视频">
				<el-upload
					class="upload-demo"
					:http-request="
						(file) => {
							return upload_video(file);
						}
					"
					accept=".mp4"
					action="#"
					:before-upload="beforeUploadVideo"
					:on-preview="handlePreview"
					:on-remove="handleRemove"
					:before-remove="beforeRemove"
					:file-list="fileList"
				>
					<el-button size="small" type="primary">点击上传</el-button>
				</el-upload>
				<el-button size="small" type="primary" @click="select_video"
					>视频库选择</el-button
				>
				<p class="text">请保证视频格式正确，且不超过10M</p>
			</el-form-item>
			<div style="margin-left: 40%;">
				<el-button @click="$router.back(-1)">
					返回
				</el-button>
				<el-button type="primary" @click="next('form')">下一步</el-button>
			</div>
		</el-form>
		<el-dialog
			title="视频库"
			:visible.sync="Isvideo_List"
			:before-close="handleClose"
		>
			<el-table
				:data="video_Lists"
				@selection-change="handleSelectionChange"
				ref="mulitipleTable"
				:row-key="
					(row) => {
						return row.id;
					}
				"
			>
				<el-table-column type="selection" width="55" :reserve-selection="true">
				</el-table-column>
				<el-table-column property="id" label="Id" width="150"></el-table-column>
				<el-table-column
					property="name"
					label="视频名称"
					width="200"
				></el-table-column>
				<el-table-column
					property="create_time"
					label="创建时间"
					width="200"
				></el-table-column>
				<el-table-column property="url" label="视频地址">
					<template slot-scope="scope">
						<video
							style="width: 150px;height: 100px;"
							v-bind:src="scope.row.url"
							controls="controls"
						>
							您的浏览器不支持视频播放
						</video>
					</template>
				</el-table-column>
			</el-table>
			<div style="display: flex;">
				<div class="block" style="margin: 20px;">
					<el-pagination
						layout="prev, pager, next"
						:total="select_video_total"
						@current-change="select_video_change"
					>
					</el-pagination>
				</div>
				<div style="margin: 20px;">
					<el-button type="primary" @click="select_video_submit"
						>保存</el-button
					>
					<el-button type="primary" @click="handleClose">取消</el-button>
					<el-button type="danger" @click="video_list_del">删除</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { areajson } from "@/components/public/area";
import {
  douyin_activity,
  Douyin_add,
  Douyin_detail,
  Douyin_edit,
  Douyin_room,
  up_video,
  video_del,
  video_getList
} from "@/api/Douyin";
import { Loading } from "element-ui";
import store from "@/store/index";

function randomString(e) {
	e = e || 10;
	var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
		a = t.length,
		n = "";
	for (var i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
	return n;
}
export default {
	data() {
		return {
			active: 0,
			fileList: [],
			options: areajson,
			room: {},
			douyin_selects: {},
			page: 0,
			douyin_Location: [],
			roomList: [],
			video_Lists: [],
			Isvideo_List: false,
			form: {
				selectedOptions: [],
				app_id: store.getters.app_id,
				room_id: "",
				title: "",
				province: "",
				city: "",
				area: "",
				address: "",
				room_name: "",
				poi_id: "",
				poi_name: "",
				location: 0,
				video: "",
				start_time: "",
				end_time: "",
			},
			select_video_list: [],
			select_video_total: 0,
			select_video_page: 1,
			rules: {
				title: [{ required: true, message: "请输入活动标题", trigger: "blur" }],
				address: [
					{ required: true, message: "请输入详细地址", trigger: "blur" },
				],
				room_id: [{ required: true, message: "请选择门店", trigger: "change" }],
				poi_name: [
					{ required: true, message: "请选择抖音地址", trigger: "change" },
				],
				selectedOptions: [
					{
						required: true,
						type: "array",
						message: "请选择抖音地址",
						trigger: "change",
					},
				],
			},
		};
	},
	mounted() {
		this.init();
	},
	methods: {
		val(val) {
			console.log(val);
		},
		async video_list_del() {
			try {
				let str = "";
				for (let i = 0; i < this.select_video_list.length; i++) {
					if (i < this.select_video_list.length - 1) {
						str += this.select_video_list[i].id + ",";
					} else {
						str += this.select_video_list[i].id;
					}
				}
				const res1 = await this.$confirm(
					"确定删除? 此操作将会在视频库中进行删除"
				);
				console.log(res1);
				if (res1 == "confirm") {
					const res = await video_del({
					  app_id:store.getters.app_id,
					  id:str
					});
					if(res.code == 200) {
            this.$message.success(res.msg)
            await this.video_List()
					}else{
					  this.$message.error(res.msg)
					}
				}
			} catch (e) {
				console.log(e);
			}
		},
		//多选
		handleSelectionChange(val) {
			console.log("....", val);
			// debugger
			if (val.length > 2) {
				let hash = {};
				const data2 = val.reduce((preVal, curVal) => {
					hash[curVal.id]
						? ""
						: (hash[curVal.id] = true && preVal.push(curVal));
					return preVal;
				}, []);
				this.select_video_list = data2;
			} else {
				this.select_video_list = val;
			}
		},

		//视频库分页
		select_video_change(val) {
			this.select_video_page = val;
			this.video_List();
		},
		//关闭对话框
		handleClose() {
			this.Isvideo_List = false;
			// this.select_video_list = [];
		},
		//多选后保存
		select_video_submit() {
			if (this.select_video_list.length > 2) {
				let hash = {};
				const data2 = this.select_video_list.reduce((preVal, curVal) => {
					hash[curVal.id]
						? ""
						: (hash[curVal.id] = true && preVal.push(curVal));
					return preVal;
				}, []);
				this.fileList = data2;
			} else {
				this.fileList = this.select_video_list;
			}

			// this.select_video_list = data2;

			this.Isvideo_List = false;
		},
		//弹出对话框并请求数据
		select_video() {
			this.Isvideo_List = true;
			// this.toggleSelection(this.fileList);
			// this.handleSelectionChange(this.fileList)
			this.video_List();
		},
		//视频库列表
		async video_List() {
			const res = await video_getList({
				app_id: store.getters.app_id,
				room_id: this.form.room_id,
				page: this.select_video_page,
			});
			if (res.code == 200) {
				console.log("22222");
				this.video_Lists = res.data.data;
				this.select_video_total = res.data.total;
				this.video_Lists.forEach((item, i) => {
					if (this.$route.query.id) {
						if (!this.Isvideo_List) {
							this.form.video_list.forEach((v, i) => {
								if (v.id == item.id) {
									this.fileList.push(item);
								}
							});
						} else {
							// debugger
							this.fileList.forEach((_item, _i) => {
								if (item.id == _item.id) {
									this.$refs.mulitipleTable.toggleRowSelection(item);
								}
							});
						}
					} else {
						// debugger
						if (this.fileList.length > 0) {
							// let arr = [];
							this.fileList.forEach((_item, _i) => {
								if (_item.id == item.id) {
									// arr.push(_item);
									this.$refs.mulitipleTable.toggleRowSelection(item);
								}
							});
							// this.toggleSelection(arr);
						} else {
							this.$refs.mulitipleTable.clearSelection();
						}
					}
				});

				// this.toggleSelection([res.data.data[1]]);
			}
		},
		//初始化
		init() {
			this.selectStoreList_med();
			if (this.$route.query.id) {
				this.Detail();
			}
			var now = new Date();
			var year = now.getFullYear(); //得到年份
			var month = now.getMonth() + 1; //得到月份
			var date = now.getDate(); //得到日期
			month = month.toString().padStart(2, "0");
			date = date.toString().padStart(2, "0");
			var hour1 = " 00:00:00";
			var hour2 = " 23:59:59";
			this.form.start_time = `${year}-${month}-${date}${hour1}`;
			this.form.end_time = `${year}-${month}-${date}${hour2}`;
		},

		//门店选择
		room_select(val) {
			console.log(val);
			this.form.room_name = val.name;
			let str = val.area.trim();
			this.form.selectedOptions = str.split(" ");
			this.form.city = this.form.selectedOptions[1];
			this.form.province = this.form.selectedOptions[0];
			this.form.area = this.form.selectedOptions[2];
			this.form.address = val.address;
			console.log(this.form.selectedOptions);
		},
		//选择抖音地址
		douyin_select(val) {
			this.form.poi_id = val.poi_id;
			this.form.location = val.location;
		},

		//获取门店下拉列表
		async selectStoreList_med() {
			const res = await Douyin_room({
				app_id: store.getters.app_id,
			});
			if (res.code == 200) {
				this.roomList = res.data;
			}
		},
		//获取详情
		async Detail() {
			try {
				const res = await Douyin_detail({
					app_id: store.getters.app_id,
					id: this.$route.query.id,
				});
				if (res.code == 200) {
					this.form = res.data;
					var area =
						this.form.province + "," + this.form.city + "," + this.form.area;
					this.Douyin_dizhi();
					this.form.selectedOptions = area.split(",");
					if (this.form.coupon) {
						var arr = this.form.coupon.split(",");
						arr.forEach((item, i) => {
							arr[i] = Number(arr[i]);
						});
						this.form.coupon = arr;
						this.couponList_med();
					}
					this.video_List();
				}
			} catch (e) {
				console.log(e);
			}
		},
		//选择三级联动
		liandong_val(val) {
			try {
				this.form.province = val[0];
				this.form.city = val[1];
				this.form.area = val[2];
			} catch (e) {
				console.log(e);
			}
		},
		//抖音滚动加载
		Douyin_dizhi_load() {
			this.page++;
			this.Douyin_dizhi();
		},
		//抖音下拉框隐藏
		visibleChange(val) {
			if (!val) {
				this.douyin_Location = [];
			} else {
				this.page = 0;
				this.Douyin_dizhi();
			}
		},
		//抖音地址失去焦点
		Douyin_dizhi_blur() {
			this.douyin_Location = [];
		},
		//获取抖音地址
		async Douyin_dizhi() {
			var data = {
				app_id: store.getters.app_id,
				city:
					this.form.city == "市辖区" || this.form.city == "县"
						? this.form.province
						: this.form.city,
				keyword: this.form.address,
				limit: 20,
				page: this.page,
			};
			const res = await douyin_activity(data);
			if (res.code == 200) {
				if (res.data.pois) {
					this.douyin_Location = this.douyin_Location.concat(res.data.pois);
				} else {
					this.$message.info("暂无数据");
				}
			}
		},
		//提交
		next(formName) {
			// console.log(this.form.video);
			let start = Date.parse(this.form.start_time);
			let end = Date.parse(this.form.end_time);
			this.$refs[formName].validate((valid) => {
				if (valid) {
					let str = "";
					for (let i = 0; i < this.fileList.length; i++) {
						if (i < this.fileList.length - 1) {
							str += this.fileList[i].id + ",";
						} else {
							str += this.fileList[i].id;
						}
					}
					this.form.video = str;
					if (
						this.form.video != "" &&
						this.form.start_time != "" &&
						this.form.end_time != ""
					) {
						if (start > end) {
							this.$message.error("开始时间不能大于结束时间");
						} else {
							if (this.form.coupon) {
								this.form.coupon = this.form.coupon.join(",");
							}
							delete this.form.sn;
							delete this.form.create_time;
							delete this.form.update_time;
							delete this.form.delete_time;
							delete this.form.url;
							delete this.form.status;
							delete this.form.first_jump;
							delete this.form.selectedOptions;
							if (this.$route.query.key == "edit") {
								this.form.video_list = this.fileList;
								Douyin_edit(this.form).then((res_edit) => {
									if (res_edit.code == 200) {
										this.$message.success(res_edit.msg);
										this.$emit("Active", 1);
										this.$router.push({
											path:
												"/apply/newVip/13/market/marketing/client/activity_Douyin/set_activity",
											query: {
												id: this.$route.query.id,
												key: "edit",
											},
										});
									} else {
										var arr = this.form.coupon.split(",");
										arr.forEach((item, i) => {
											arr[i] = Number(arr[i]);
										});
										this.form.coupon = arr;
										this.$message.error(res_edit.msg);
									}
								});
							} else {
								this.form.nonce_str = this.form.nonce_str
									? this.form.nonce_str
									: randomString(8);
								Douyin_add(this.form).then((res) => {
									if (res.code == 200) {
										this.$message.success(res.msg);
										this.$emit("Active", 1);
										this.$router.push({
											path:
												"/apply/newVip/13/market/marketing/client/activity_Douyin/set_activity",
											query: {
												id: res.data.id,
												key: "add",
											},
										});
									} else {
										var arr = this.form.coupon.split(",");
										arr.forEach((item, i) => {
											arr[i] = Number(arr[i]);
										});
										this.form.coupon = arr;
										this.$message.error(res.msg);
									}
								});
							}
						}
					} else {
						this.$message.error("请检查日期是否填写或者视频是否上传成功");
					}
				} else {
					this.$message.error("请填写必填项!!!");
					return false;
				}
			});
		},
		//视频上传
		//验证格式
		beforeUploadVideo(file) {
			const isLt10M = file.size / 1024 / 1024 < 10;
			if (
				[
					"video/mp4",
					"video/ogg",
					"video/flv",
					"video/avi",
					"video/wmv",
					"video/rmvb",
				].indexOf(file.type) == -1
			) {
				this.$message.error("请上传正确的视频格式");
				return false;
			}
			if (!isLt10M) {
				this.$message.error("上传视频大小不能超过10MB哦!");
				return false;
			}
		},

		handleRemove(file, fileList) {
			console.log(file, fileList);
			this.fileList = fileList;
			this.select_video_list.forEach((item, i) => {
				if (item.id == file.id) {
					delete this.select_video_list[i];
				}
			});
		},
		handlePreview(file) {
			console.log(file);
		},
		beforeRemove(file, fileList) {
			this.$confirm(`确定移除 ${file.name}？`);
			this.fileList = fileList;
		},

		//视频上传请求
		upload_video(file) {
      let loadingInstance = Loading.service({
        fullscreen: false,
        target: document.querySelector("body"),
        lock: true,
        text: "视频上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.9)"
      })
			var formdata = new FormData();
			formdata.append("video", file.file);
			formdata.append("app_id", store.getters.app_id);
			formdata.append("room_id", this.form.room_id);
			up_video(formdata).then((res) => {
				console.log("上传回调", res);
				if (res.code == 200) {
					this.fileList.push(res.data);
					console.log(this.fileList);
					this.$message.success("上传成功");
          this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          });
				} else {
					this.$message({
						message: res.msg,
						type: "warning",
					});
          this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          });
				}
			});
		},
	},
};
</script>
<style lang="scss" scoped>
.el-input {
	width: 350px !important;
}
.step {
	width: 100%;
	height: 5vw;
	margin: 0 auto;
}
.el-upload-list__item-name {
	width: 500px !important;
}
</style>
